import React from "react";
import StylishSelect from "../stylish-select/StylishSelect";

const PortaledSelect = (props) => {
  const newStyles = {...props.styles, menuPortal: base => ({ ...base, zIndex: 9999 }) }
  return (<StylishSelect
    {...props}
    menuPortalTarget={document.body}
    styles={{...newStyles}}
  />)
}
export default PortaledSelect
